import React from "react";
import { Link, LinkProps } from "react-router-dom";
import {useNavigationBlocker} from "../navigation-blocker/navigation-blocker";

const ProtectedLink: React.FC<LinkProps> = ({ children, ...rest }) => {
    const { showBlocker } = useNavigationBlocker();
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (showBlocker(rest.to as string)) {
            e.preventDefault();
        }
    };

    return (
        <Link {...rest} onClick={handleClick}>
            {children}
        </Link>
    );
};

export default ProtectedLink;
